/* tslint:disable */
/* eslint-disable */
/**
 * Organization service API
 * Service for Organizations management
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  LeiTestStatus,
} from '../models/index';
import {
    LeiTestStatusFromJSON,
    LeiTestStatusToJSON,
} from '../models/index';

export interface SetLeiTestStatusRequest {
    lei: string;
    leiTestStatus: LeiTestStatus;
}

export interface UpdateTestGLEIFClientBehaviourRequest {
    body: string;
}

/**
 * 
 */
export class GleifAPITestControllerApi extends runtime.BaseAPI {

    /**
     * Clean up mocked GLEIF
     */
    async cleanTestGLEIFClientBehaviourRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<string>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/v1/org/.private/gleif/behaviour`,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<string>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Clean up mocked GLEIF
     */
    async cleanTestGLEIFClientBehaviour(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<string> {
        const response = await this.cleanTestGLEIFClientBehaviourRaw(initOverrides);
        return await response.value();
    }

    /**
     * Clean up lei mocked statuses
     */
    async clearLeiStatusesRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<string>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/v1/org/.private/gleif`,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<string>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Clean up lei mocked statuses
     */
    async clearLeiStatuses(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<string> {
        const response = await this.clearLeiStatusesRaw(initOverrides);
        return await response.value();
    }

    /**
     * Configure lei mocked status
     */
    async setLeiTestStatusRaw(requestParameters: SetLeiTestStatusRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<string>> {
        if (requestParameters['lei'] == null) {
            throw new runtime.RequiredError(
                'lei',
                'Required parameter "lei" was null or undefined when calling setLeiTestStatus().'
            );
        }

        if (requestParameters['leiTestStatus'] == null) {
            throw new runtime.RequiredError(
                'leiTestStatus',
                'Required parameter "leiTestStatus" was null or undefined when calling setLeiTestStatus().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/v1/org/.private/gleif/{lei}/status`.replace(`{${"lei"}}`, encodeURIComponent(String(requestParameters['lei']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: LeiTestStatusToJSON(requestParameters['leiTestStatus']),
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<string>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Configure lei mocked status
     */
    async setLeiTestStatus(requestParameters: SetLeiTestStatusRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<string> {
        const response = await this.setLeiTestStatusRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Configure mocked GLEIF
     */
    async updateTestGLEIFClientBehaviourRaw(requestParameters: UpdateTestGLEIFClientBehaviourRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<string>> {
        if (requestParameters['body'] == null) {
            throw new runtime.RequiredError(
                'body',
                'Required parameter "body" was null or undefined when calling updateTestGLEIFClientBehaviour().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/v1/org/.private/gleif/behaviour`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['body'] as any,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<string>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Configure mocked GLEIF
     */
    async updateTestGLEIFClientBehaviour(requestParameters: UpdateTestGLEIFClientBehaviourRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<string> {
        const response = await this.updateTestGLEIFClientBehaviourRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
